export const VENDOR_LISTINGS_TOOLTIP_MAX_SHOWS = 3;
const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;
export const VENDOR_LISTINGS_TOOLTIP_SHOWN_COUNT_COOKIE_EXPIRY_MS = 365 * ONE_DAY_IN_MILLISECONDS;
export const VENDOR_LISTINGS_TOOLTIP_HIDDEN_COOKIE_EXPIRY_MS = ONE_DAY_IN_MILLISECONDS;

// the listings nav item is hidden below @navbar-collapse-breakpoint (navbar.less), so the tooltip is skipped there
export const NAVBAR_COLLAPSED_QUERY = '(max-width: 1119px)';

export const getVendorListingsTooltipShownCountCookieName = (ssoId) => `vendor_listings_tooltip_shown_count_${ssoId}`;
export const getVendorListingsTooltipHiddenCookieName = (ssoId) => `vendor_listings_tooltip_hidden_${ssoId}`;
